import {createContext, Suspense, useEffect, useState} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {isBrowser, isMobile} from "react-device-detect";
import ScrollToTop from "react-scroll-up";
import {Button} from "reactstrap";
import {ArrowUp} from "react-feather";
import themeConfig from "@configs/themeConfig";
import {getUI} from '@store/actions/UI';
import {handleToggle} from "@utils/handleToggle";
import Header from "./components/headers/Header4";
import Login from './components/login';
import Footer from './components/footers/Footer3';
import FloatingContact from "./components/floatingContact";
import "./style.scss";

export const ContextLayout = createContext();

const WebLayout = () => {
    // const [isRtl, setIsRtl] = useRTL();
    // const [skin, setSkin] = useSkin();

    const location = useLocation();
    const dispatch = useDispatch();
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

    // window.RAYCHAT_TOKEN = "4ee9e6d6-bd39-4971-aad7-a193dd208203";

    useEffect(() => {
        dispatch(getUI());

        // window.RAYCHAT_TOKEN = "4ee9e6d6-bd39-4971-aad7-a193dd208203";

        /*const handleRayChat = () => {
            let d = document;
            let s = d.createElement("script");
            s.src = "https://widget-react.raychat.io/install/widget.js";
            s.async = 1;
            d.getElementsByTagName("head")[0].appendChild(s);

            /!* window.Raychat?.setStyle({
                 backgroundColor: '#F29727',
                 height:"100px",
                 width : "100px",
             });*!/
        };

        handleRayChat();*/

        /*return () => {
            let rayChatElement = document.getElementById("raychat_widget");
            setTimeout(() => {
                try {
                    if (rayChatElement)
                        rayChatElement.remove();
                } catch (e) {
                }
            }, 1000)
        };*/
    }, [dispatch, location.pathname]);

    // Render a suspense fallback while the Outlet is being loaded
    return (
        <div
            className={`web-layout${(isMobile && (location.pathname.includes("/product/") || location.pathname.includes("/cart"))) ? ' bottom-space' : ''}`}>
            <Suspense fallback={null}>
                <ContextLayout.Provider
                    value={{
                        showLoginModal: () => {
                            handleToggle(setIsLoginModalOpen);
                        },
                        isLoginModalOpen: isLoginModalOpen,
                    }}
                >
                    {/*<Notice/>*/}

                    <Header withoutCurve location={location}/>

                    <main className='web-layout-content'>
                        {/*<Helmet>
                            <title>فروشگاه وسام</title>
                        </Helmet>*/}

                        <Outlet/>
                    </main>

                    {
                        location.pathname.includes("/cart") && isMobile ? null : <Footer/>
                    }


                    {(!isMobile && themeConfig.layout.scrollTop === true) ? (
                        <div className='scroll-to-top'>
                            <ScrollToTop showUnder={300} style={{bottom: "2%", right: "20px"}}>
                                <Button className='btn-icon' color='secondary'>
                                    <ArrowUp size={16}/>
                                </Button>
                            </ScrollToTop>
                        </div>
                    ) : null}

                    <Login/>
                </ContextLayout.Provider>
            </Suspense>

            {
                !location.pathname.includes("/cart") &&
                <div className='d-flex align-items-center justify-content-between'>
                    <FloatingContact/>
                    {/*<FloatingGallery/>*/}
                </div>
            }

        </div>
    );
};

export default WebLayout;
